import { Loading } from "@/components";
import { Navigate } from "react-router";
import { ServiceClient } from "@/util";
import { useConfiguration } from "@/queries/configuration.queries";

export function Home() {
  const config = useConfiguration();

  if (config.isLoading) {
    return <Loading />;
  }

  if (ServiceClient.isBarcodeLogin()) {
    return <Navigate to="/rbi" replace />;
  } else if (config.data?.qualifier?.isWilliams) {
    return <Navigate to="/williams" replace />;
  } else if (config.data?.coordinator?.isAep) {
    return <Navigate to="/datasheets" replace />;
  } else if (config.data?.qualifier) {
    return <Navigate to="/certificates" replace />;
  } else {
    return <Navigate to="/rbi" replace />;
  }
}
